import { api } from './api'

export default class ProjetoService {
    async getAll(params){
        try {
            let res = await api().get('projeto', {
                params: params
            })
    
            if(res) {
                return res.data
            }
    
            return false
        } catch (error) {
            return false
        }
    }
}